<template>
  <div v-if="contentAddDialogVisible">
    <el-dialog
      :title="title"
      :visible.sync="contentAddDialogVisible"
      :width="dialogWidth"
      :before-close="beforeClose"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="form" v-if="contentAddDialogVisible">
        <!-- 循环当前传过来的数据结构 -->
        <el-form-item
          v-for="(item, i) in formDataList"
          :key="i"
          :rules="item.rules || []"
          :prop="item.key"
        >
          <!-- 输入框 -->
          <el-row v-if="item.type === 'text'">
            <el-col :span="keySpan">
              {{ item.label }}
            </el-col>
            <el-col :span="valueSpan">
              <el-input
                :type="item.inputText || 'text'"
                v-model="form[item.key]"
                :placeholder="item.placeholder || '请输入内容'"
                :disabled="item.disabled || false"
              ></el-input>
            </el-col>
          </el-row>
          <!-- 选择器 -->
          <el-row v-if="item.type === 'select'">
            <el-col :span="keySpan">
              {{ item.label }}
            </el-col>
            <el-col :span="valueSpan">
              <el-select
                style="width: 100%"
                v-model="form[item.key]"
                clearable
                :placeholder="item.placeholder || '请选择'"
                :multiple="item.multiple || false"
                :filterable="item.filterable || false"
                :allow-create="item['allow-create'] || false"
              >
                <el-option
                  v-for="item in item.option"
                  :key="item.id"
                  :label="item[item.labelKey || 'title']"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row v-if="item.type === 'date'">
            <el-col :span="keySpan">
              {{ item.label }}
            </el-col>
            <el-col :span="item.valueSpan || valueSpan">
              <el-date-picker
                v-model="form[item.key]"
                :type="item.dateType || 'date'"
                :placeholder="item.placeholder || '请选择'"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row v-if="item.type === 'datetime'">
            <el-col :span="keySpan">
              {{ item.label }}
            </el-col>
            <el-col :span="item.valueSpan || valueSpan">
              <el-date-picker
                v-model="form[item.key]"
                :type="item.dateType || 'datetime'"
                :placeholder="item.placeholder || '请选择'"
                align="right"
                :picker-options="pickerOptions"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row v-if="item.type === 'upimg'">
            <el-col :span="keySpan">
              {{ item.label }}
            </el-col>
            <el-col :span="valueSpan">
              <el-upload
                :action="upImgUrl"
                list-type="picture-card"
                :on-success="
                  (e) => {
                    onUpImgSuccess(e, item.key);
                  }
                "
                :show-file-list="false"
                :on-remove="removeImg"
                name="file"
              >
                <div class="img">
                  <img
                    :src="$fnc.getImgUrl(form[item.key])"
                    alt=""
                    v-if="form[item.key]"
                  />
                  <i class="el-icon-plus" v-else></i>
                </div>
              </el-upload>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- 插槽 -->
        <el-form-item v-for="item in slotList" :key="item.labelName">
          <el-row>
            <el-col :span="keySpan">
              <slot :name="item.labelName"></slot>
            </el-col>
            <el-col :span="valueSpan">
              <slot :name="item.valueName"></slot>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <slot> </slot>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="contentAddDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    // 表单列表
    formData: {
      type: Array,
      default() {
        return [];
      },
    },
    // label宽度
    keySpan: {
      type: Number,
      default: 2,
    },
    // 表单宽度
    valueSpan: {
      type: Number,
      default: 22,
    },
    // 编辑的表单列表
    editFormData: {
      type: Array,
      default() {
        return [];
      },
    },
    // 插槽列表
    slotList: {
      type: Array,
      default() {
        return [];
      },
    },
    // 弹框类型为编辑时  直接将请求方法放进来
    getEditForm: {
      type: Function,
      default() {
        return () => {};
      },
    },
    // 获取编辑数据时 参数key
    idKey: {
      type: String,
      default: "id",
    },
    dialogWidth: {
      type: String,
      default: "50%",
    },
  },
  data() {
    return {
      form: {},
      contentAddDialogVisible: false,
      title: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      type: "add",
      arr: [],
      formDataList: [],
      editId: "",
    };
  },
  components: {},
  methods: {
    // 打开弹框  获取对应的类型  如果是编辑时则获取id
    openDialog(title, type = "add", id, editInfo = {}) {
      this.title = title || "未填写标题";
      // this.formrr.map(item => item.key).forEach(item => this.form[item] = '')
      this.type = type;
      this.editId = id || "";
      this.form.id = "";
      this.form = {};
      this.formDataList = JSON.parse(JSON.stringify(this.formData));
      if (type == "edit") {
        // 获取编辑数据
        this.formDataList.forEach((item) => {
          item[item.key] = "";
          for (const key in editInfo) {
            if (item.key === key) {
              item[key] = editInfo[key];
              this.$set(this.form, key, item[key]);
            }
          }
        });
        this.form.id = id;
      }
      this.contentAddDialogVisible = true;
    },
    beforeClose() {
      this.contentAddDialogVisible = false;
    },
    // 图片上传成功
    onUpImgSuccess(e, key) {
      this.$set(this.form, key, e.data);
    },
    // 保存
    onSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let form = this.getFormData();
          this.$emit("onSave", form, this.type);
          this.contentAddDialogVisible = false;
        } else {
          return false;
        }
      });
    },
    // 获取当前表单所有值
    getFormData() {
      let newForm = {};
      // this.formDataList.forEach((item, i) => {
      //   newForm[item.key] = item[item.key] || ''
      // })
      if (this.type == "edit") {
        newForm[this.idKey] = this.editId;
      }
      return this.form;
    },
  },
  created() {
    this.arr = [...this.formData];
  },
};
</script>
<style lang="less" scoped>
.img {
  width: 148px;
  height: 148px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #909399;
  border-radius: 3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  font-size: 30px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>